"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppEditorBiomeFeature = AppEditorBiomeFeature;
const biome_ai_web_1 = require("@branch-ts/biome-ai-web");
const biome_media_web_1 = require("@branch-ts/biome-media-web");
function AppEditorBiomeFeature(config) {
    (0, biome_ai_web_1.AIWebBiome)({
        intelligenceCenter: config.intelligenceCenter,
        editorKinds: config.editorKinds,
        terminalDomains: config.terminalDomains,
        terminalActivities: config.terminalActivities,
        onMissingTerminal: config.onMissingTerminal,
    });
    (0, biome_media_web_1.MediaWebBiome)({
        editorKinds: config.editorKinds,
        store: config.storage,
        onMissingFileSystem: config.onMissingFileSystem,
    });
}
